(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(routes);

    routes.$inject = ['$stateProvider'];

    function routes($stateProvider) {
        $stateProvider
            .state('accountManagement.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.verify', {
                url: '/verify',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.reset-password-token', {
                url: '/reset-password-token',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('accountManagement.request-verification-email', {
                url: '/request-verification-email',
                templateUrl: 'app/components/dashboard/dashboard.view.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            });
    }
})();
